import { ProgramWizardConfig, ProgramWizardMetadata } from './types';
import { createContext, useContext } from 'react';

export type ProgramWizardState = {
  config: ProgramWizardConfig;
  metadata: ProgramWizardMetadata;
};

const ProgramWizardContext = createContext<ProgramWizardState | undefined>(
  undefined,
);

export const ProgramWizardContextProvider = ProgramWizardContext.Provider;

export const useProgramWizardContext = (): ProgramWizardState => {
  const context = useContext(ProgramWizardContext);
  if (!context) {
    throw Error(
      `Could not find ProgramWizardContext in the component hierarchy.`,
    );
  }
  return context;
};
